export type ManagedImageVariantKind = "original" | "edited";
export type ManagedImageBusyAction = "delete" | "applyEdit" | "restoreOriginal" | "saving" | null;

export interface ManagedImageVariantValue {
  url?: string;
  thumbnailUrl?: string;
  downloadUrl?: string;
  file?: {
    name: string;
    path: string;
    size: number;
    mimetype: string;
    thumbnailPath?: string;
  };
}

export interface ManagedImageValue {
  hasImage: boolean;
  hasEdited: boolean;
  canEdit: boolean;
  canRestoreOriginal: boolean;
  hasBackgroundRemoved?: boolean;
  activeVariant?: ManagedImageVariantKind;
  active?: ManagedImageVariantValue;
  original?: ManagedImageVariantValue;
  edited?: ManagedImageVariantValue;
}

export interface ManagedImageEditRequest {
  crop?: {
    x: number;
    y: number;
    width: number;
    height: number;
  };
  removeBackground?: boolean;
}

export type ManagedImageDraftFile = File & {
  originalFile?: File;
  pendingEdits?: ManagedImageEditRequest;
};

/**
 * Attaches media draft metadata to a `File` instance so form state can keep
 * both the original upload and the accumulated edit instructions together.
 */
export const attachManagedImageDraftMetadata = (
  file: File,
  metadata: Partial<Pick<ManagedImageDraftFile, "originalFile" | "pendingEdits">>,
): ManagedImageDraftFile => Object.assign(file, metadata);

export const getManagedImageOriginalFile = (file: File): File => {
  const draftFile = file as ManagedImageDraftFile;
  return draftFile.originalFile || file;
};

export const getManagedImagePendingEdits = (file?: File | null): ManagedImageEditRequest | undefined =>
  (file as ManagedImageDraftFile | null | undefined)?.pendingEdits;
